import React from 'react';
import { Clock, BookOpen, TrendingUp, Building2 } from 'lucide-react';
export function Benefits() {
  return <section className="py-20 bg-white" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-3">
          <div className="flex flex-col items-center text-center group" data-id="element-4">
            <div className="bg-pink-600 p-4 rounded-2xl shadow-lg mb-6 transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3" data-id="element-5">
              <Clock className="w-8 h-8 text-white" data-id="element-6" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-7">
              Ahorro de Tiempo
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-8">
              No pierdas horas planificando. Todo listo para aplicar
              directamente en clase.
            </p>
          </div>

          <div className="flex flex-col items-center text-center group" data-id="element-9">
            <div className="bg-gray-900 p-4 rounded-2xl shadow-lg mb-6 transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3" data-id="element-10">
              <BookOpen className="w-8 h-8 text-white" data-id="element-11" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-12">
              Contenido Completo
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-13">
              Material digital descargable con planificaciones, dinámicas y
              recursos listos para usar.
            </p>
          </div>

          <div className="flex flex-col items-center text-center group" data-id="element-14">
            <div className="bg-pink-600 p-4 rounded-2xl shadow-lg mb-6 transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3" data-id="element-15">
              <TrendingUp className="w-8 h-8 text-white" data-id="element-16" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-17">
              Sistema Progresivo
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-18">
              Contenido pedagógico estructurado por niveles para garantizar el
              avance real.
            </p>
          </div>

          <div className="flex flex-col items-center text-center group" data-id="element-19">
            <div className="bg-gray-900 p-4 rounded-2xl shadow-lg mb-6 transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3" data-id="element-20">
              <Building2 className="w-8 h-8 text-white" data-id="element-21" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-22">
              Versatilidad Total
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-23">
              Ideal para academias, escuelas formales y talleres independientes.
            </p>
          </div>
        </div>
      </div>
    </section>;
}